import minimatch from './index.js'

export = Object.assign(minimatch, { default: minimatch, minimatch })
